import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {ToastService} from '../toast/toast-service';

export const IGNORE_5XX_ERROR = new HttpContextToken<boolean>(() => false);

export function http5xxInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const toastService = inject(ToastService);

  if (req.context.get(IGNORE_5XX_ERROR)) {
    return next(req)
  }
  return next(req).pipe(tap(event => {
  }, err => {
    handleError(err, toastService);
  }));
}

function handleError(err: HttpErrorResponse, toastService: ToastService) {
  if (err.status >= 500 && err.status < 600) {
    const message = extractErrorMessage(err);
    toastService.error(message);
  }
}

function extractErrorMessage(err: HttpErrorResponse): string {
  // Try to extract error message from the error response
  if (err.error) {
    const errorBody = err.error;

    // Case 1: errorBody is a string
    if (typeof errorBody === 'string') {
      return errorBody;
    }

    // Case 2: errorBody is an object with message property
    if (typeof errorBody === 'object') {
      if (errorBody.message) {
        return errorBody.message;
      }
      if (errorBody.error && typeof errorBody.error === 'string') {
        return errorBody.error;
      }
      if (errorBody.error && typeof errorBody.error === 'object' && errorBody.error.message) {
        return errorBody.error.message;
      }
    }
  }

  // Default error messages based on status code
  const defaultMessages: Record<number, string> = {
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    505: 'HTTP Version Not Supported',
    506: 'Variant Also Negotiates',
    507: 'Insufficient Storage',
    508: 'Loop Detected',
    510: 'Not Extended',
    511: 'Network Authentication Required'
  };

  return defaultMessages[err.status] || `Server Error (${err.status})`;
}
